/**
 * Prototype-only feature flags that are not defined in LaunchDarkly. They are
 * toggled through local `flagOverrides` in Internal Tools, so a prototype can
 * be tried without a dashboard flag.
 *
 * Main ships with an empty list, and Internal Tools hides the section until a
 * prototype branch appends `{ key, label }`.
 */
export const PROTOTYPE_FLAGS: { key: string; label: string }[] = [];
